import { SkyscannerTerraserviceApiV2 } from '@skyscanner-internal/terra-service-web-http-client';

import { grpcFetchClientWrapper } from '../../internals/clients/grpc/grpc';

export const GRPC_TERRA_GET_LOCATIONS_BY_ID_CLIENT_NAME = 'TERRA_GET_LOCATIONS_BY_ID';
export const PATH_PREFIX = '/g/terra-service';

export const terraGetLocationsById = grpcFetchClientWrapper(
  SkyscannerTerraserviceApiV2.TerraService.GetLocationsById,
  {
    clientName: GRPC_TERRA_GET_LOCATIONS_BY_ID_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
  },
);
